module.exports = __webpack_public_path__ + "static/img/IP-img3.3ea5e59c.png";